<template>
    <div class="cookies" v-if="!cookies_accepted">
        <div class="text-left">
            <p class="mb-2 font-weight-bold">{{ $t('Data processing conditions') }}</p>
            <p class="mb-0">{{ $t('Our website uses cookies') }}.</p>
            <p class="mb-0">{{ $t('Please read the terms of use of personal data') }}.</p>
            <div class="my-3">
                <a role="button" class="btn-link primary" @click="$modal.show('cookie')">
                    {{ $t('Read more') }}
                </a>
            </div>
            <app-button native-type="button" class="m-0" @click="acceptCookies" small>
                {{ $t('Accept') }}
            </app-button>
        </div>
        <cookie-modal @acceptCookies="acceptCookies" />
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import CookieModal from './modals/Cookie';

export default {
    name: 'AppCookies',
    data() {
        return {
            cookies_accepted: false
        };
    },
    methods: {
        checkCookies() {
            this.cookies_accepted = Cookies.get('1autorent_accept') === 'true';
        },
        acceptCookies() {
            Cookies.set('1autorent_accept', 'true', { expires: 365 });
            this.cookies_accepted = true;
        }
    },
    components: {
        CookieModal
    },
    created() {
        this.checkCookies();
    }
};
</script>
<style scoped>
.cookies {
    z-index: 1000;
    background: #f5f8ff;
    position: fixed;
    bottom: 8px;
    left: 8px;
    padding: 1%;
    border-radius: 0.1rem;
    border: 1px solid #17a2b8;
    color: black;
    box-shadow: 3px 3px 5px 5px rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
</style>
